import { render, staticRenderFns } from "./ClassroomDetailTabMyTasksCreate.vue?vue&type=template&id=5f71aa3c&scoped=true"
import script from "./ClassroomDetailTabMyTasksCreate.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMyTasksCreate.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMyTasksCreate.vue?vue&type=style&index=0&id=5f71aa3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f71aa3c",
  null
  
)

export default component.exports